import { useCallback } from 'react';
import useUserPreferenceId from '~/client/hooks/cookies/useUserPreferenceId';
import useSite from '~/client/hooks/useSite';
import type { Currency } from '~/schema/public';
import { CurrentUserQueryDocument } from '~/shared/graphql/user/CurrentUserQuery.generated';
import { useSportsbetUpdateCurrencyMutation } from './SportsbetUpdateCurrencyMutation.generated';

const useSportsbetUpdateCurrency = () => {
  const [id] = useUserPreferenceId();
  const { site } = useSite();
  const [sportsbetUpdateCurrency, { loading, error }] =
    useSportsbetUpdateCurrencyMutation();

  const updateCurrency = useCallback(
    async (currency: string) => {
      await sportsbetUpdateCurrency({
        variables: { input: { id, currency: currency as Currency } },
        refetchQueries: [
          { query: CurrentUserQueryDocument, variables: { site } },
        ],
      });
    },
    [id, site, sportsbetUpdateCurrency],
  );

  return { loading, error, updateCurrency };
};

export default useSportsbetUpdateCurrency;
